import {Service} from "@/services/Service";

export class DashboardService extends Service {
    constructor(axios) {
        super(axios, "/dashboard");
        // this.fields = [
        //     "username": this.$localStorageService.,
        //     "password": "",
        // ]
    }

    obtenerReporte(fcInicio, fcFin) {
        this.onStart();
        const filtro = {
            fcInicio: fcInicio,
            fcFin: fcFin
        }
        return this.http.post(this.getUrl(['/obtenerReporte/']), filtro)
            .then((response) => {
                // console.info("----", response.data);
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerImagen(token) {
        return this.http.get(this.getUrlQuery(['/obtenerImagen/'], [token]))
            .then((response) => response.data)
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}